var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { decode, decodeAsync } from "@msgpack/msgpack";
const partiallyReadResponse = (decodedResponse) => {
    const [id, data, error] = decodedResponse;
    const [status, errorData, description] = (error || []);
    const result = errorData ? {
        id,
        error: { status, data: errorData, description }
    } : {
        id,
        data,
    };
    return result;
};
export const msgPackResponseFormatter = (payload) => __awaiter(void 0, void 0, void 0, function* () {
    if (typeof payload.data.stream === "function" || typeof payload.data.arrayBuffer === "function") {
        try {
            let decodedResponse;
            if (payload.data.stream) {
                decodedResponse = yield decodeAsync(payload.data.stream());
            }
            else {
                const arrayBuffer = yield payload.data.arrayBuffer();
                decodedResponse = decode(arrayBuffer);
            }
            return partiallyReadResponse(decodedResponse);
        }
        catch (e) {
            //this error fill the logs because of unsupported browser and for that reason it is skipped
        }
    }
    return {};
});
//# sourceMappingURL=msgPackResponseFormatter.js.map